export default "__VITE_ASSET__sJgxIIzw__"